import { createAction, props } from '@ngrx/store';
import { TestletType } from '../../constants/testlet-type.enum';
import { StoreConstants } from '../constants/store-constants';

export const loadNextPage = createAction(
  `[${StoreConstants.STORE_KEY}] load next page`,
  props<{ nextPage: TestletType | string }>(),
);

export const loadNextPageSuccess = createAction(
  `[${StoreConstants.STORE_KEY}] load next page success`,
  props<{ pageToLoad: TestletType | string }>(),
);

export const loadNextPageFailure = createAction(
  `[${StoreConstants.STORE_KEY}] load next page failure`,
  props<{ error: any }>(),
);
